const ReimbursementCategoryComponent = () => import('@/views/finance/ReimbursementCategory/ReimbursementCategoryView')

export default [
    {
        path:'/ReimbursementCategoryIndex',
        name:'ReimbursementCategoryComponent',
        component:ReimbursementCategoryComponent
    }
]